<template>
  <div>
    <ams-search
      heading="Items with Images"
      :ams_type="ams_type"
      :ams_fields="ams_fields"
      @searchFor="searchSelection"
    ></ams-search>
    <b-row>
      <b-col b-col md="4" class="my-1">
        Total {{totalRows}}
      </b-col>
      <b-col b-col md="4" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="table-transition-example"
          pills
          align="fill"
          class="my-1"
          size="sm"
        ></b-pagination>
      </b-col>
      <b-col md="4" class="my-1">
        <b-button variant="outline-primary"
          size="sm" @click="addEntry"
          v-b-tooltip.hover.right title="Add Entry"
        >
          <b-icon-plus-circle-fill> aria-label="Add Entry"></b-icon-plus-circle-fill>
        </b-button>
      </b-col>
    </b-row>
    <b-card bg-variant="light">
      <b-card-group deck>
        <div v-for="(item) in collection_images" :key="item.id">
          <item-image-association-card
            :data_item="item"
            :mappings="items"
            :included="included"
          ></item-image-association-card>
        </div>
      </b-card-group>
    </b-card>
    <b-row>
      <b-col b-col md="4" class="my-1">
        Total {{totalRows}}
      </b-col>
      <b-col b-col md="4" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="table-transition-example"
          pills
          align="fill"
          class="my-1"
          size="sm"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import AmsSearch from './AmsSearch.vue'
import ItemImageAssociationCard from './ItemImageAssociationCard.vue'

import {
  // BIconAsterisk,
  // BIconTriangle,
  BIconPlusCircleFill,
} from 'bootstrap-vue'

export default {
  components: {
    // BIconAsterisk,
    // BIconTriangle,
    BIconPlusCircleFill,
    AmsSearch,
    ItemImageAssociationCard
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    ams_template: {
      Type: Object
    }
  },
  data() {
    return {
      ams_type: 'item-image-associations',
      link: "/" + this.ams_type + "/create",
      totalRows: 0,
      currentPage: 1,
      perPage: 0,
      items: [],
      included: [],
      collection_images: [],
      ams_fields: [
        { 
          key: 'attributes.created-at',
          label: 'Created At',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
      ]
    }
  },
  methods: {
    addEntry() {
      if(this.reroute_name) {
        this.$router.push( {
          name: this.reroute_name,
          params: {
            ams_template: this.ams_template
          }
        })
      }
      else {
        this.$router.push( {
          path: this.link
        })
      }
    },
    searchSelection(searchOptions) {
       this.search_params = searchOptions
       this.callApi()
    },
    callApi () {
      http_v1.get (
        'api/admin/v1/item_image_associations', {
          params: {
            page: this.currentPage,
            ... this.filtering,
            ... this.search_params
          }
        }
      ).then(response => {
        if(response.status == 200) {
          this.totalRows = response.headers.total
          this.perPage = response.headers['per-page']
          this.items = response.data.data
          this.included = response.data.included
          this.collection_images = []
          this.included.forEach(el => {
            if( el.type === 'collection-images') {
              this.collection_images.push(el)
            }
          })
        }
        else {
          window.console.log(response.status)
        }
      }).catch(error => {
        this.items = []
        this.totalRows = 0
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          window.console.log(message)
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    // callApi () {
    //   http_v1.get (
    //     'api/admin/v1/polymorphic_references', {
    //       params: {
    //         page: this.currentPage,
    //         ... this.filtering,
    //         ... this.search_params
    //       }
    //     }
    //   ).then(response => {
    //     if(response.status == 200) {
    //       this.totalRows = response.headers.total
    //       this.perPage = response.headers['per-page']
    //       this.items = response.data.data
    //       this.included = response.data.included
    //     }
    //     else {
    //       window.console.log(response.status)
    //     }
    //   }).catch(error => {
    //     this.items = []
    //     this.totalRows = 0
    //     if( error.response && error.response.data) {
    //       var message = error.response.data.message || JSON.stringify(error.response.data)
    //       if (error.response.status === 500 ) message = "500 Server Error"
    //       window.console.log(message)
    //       this.$bvToast.toast(message, {
    //         title: 'Error',
    //         autoHideDelay: 5000,
    //         appendToast: true
    //       })
    //     }
    //   })
    // },
    // navigateToShow(data_item) {
    //   let nav = {
    //     name: 'PolymorphicReferenceShowScreen', 
    //     params: {
    //       id: data_item.id
    //     }
    //   }
    //   this.$router.push(nav)
    // },
    // navigateToUpdate(data_item) {
    //   let nav = {
    //     name: 'PolymorphicReferenceUpdateScreen', 
    //     params: {
    //       id: data_item.id
    //     }
    //   }
    //   this.$router.push(nav)
    // }
  },
  watch: {
    currentPage() {
      this.callApi()
    },
    filtering : {
      handler() {
        this.callApi()
        this.$emit('refreshed', true)
      },
      deep: true
    }
  },
  mounted() {
    this.callApi()
  }
}
</script>
